import React from "react";
import type { RCATeamMember } from "../../../../components/RCA/types";

interface RCATeamSectionProps {
  members: RCATeamMember[];
  onAdd: () => void;
  onUpdate: (index: number, field: keyof RCATeamMember, value: any) => void;
  onRemove: (index: number) => void;
  readOnly: boolean;
}

const RCATeamSection: React.FC<RCATeamSectionProps> = ({
  members,
  onAdd,
  onUpdate,
  onRemove,
  readOnly,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">
          B. List of RCA Team Members & Lead
        </h3>
        {!readOnly && (
          <button
            type="button"
            onClick={onAdd}
            className="px-4 py-2 bg-[#0fa9a6] text-white rounded hover:bg-[#0d8f8c]"
          >
            Add Team Member
          </button>
        )}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">Sr. No</th>
              <th className="border p-2">Name</th>
              <th className="border p-2">Department</th>
              <th className="border p-2">Lead</th>
              {!readOnly && <th className="border p-2">Action</th>}
            </tr>
          </thead>
          <tbody>
            {members.length === 0 ? (
              <tr>
                <td
                  colSpan={readOnly ? 4 : 5}
                  className="border p-4 text-center text-gray-500"
                >
                  No team members added
                </td>
              </tr>
            ) : (
              members.map((member, index) => (
                <tr key={index}>
                  <td className="border p-2">{member.srNo}</td>
                  <td className="border p-2">
                    <input
                      type="text"
                      value={member.name}
                      onChange={(e) =>
                        onUpdate(index, "name", e.target.value)
                      }
                      className="w-full p-1 border rounded"
                      readOnly={readOnly}
                    />
                  </td>
                  <td className="border p-2">
                    <input
                      type="text"
                      value={member.department}
                      onChange={(e) =>
                        onUpdate(index, "department", e.target.value)
                      }
                      className="w-full p-1 border rounded"
                      readOnly={readOnly}
                    />
                  </td>
                  <td className="border p-2 text-center">
                    <input
                      type="checkbox"
                      checked={member.isLead}
                      onChange={(e) =>
                        onUpdate(index, "isLead", e.target.checked)
                      }
                      disabled={readOnly}
                    />
                  </td>
                  {!readOnly && (
                    <td className="border p-2 text-center">
                      <button
                        type="button"
                        onClick={() => onRemove(index)}
                        className="text-red-600 hover:text-red-800"
                      >
                        Remove
                      </button>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RCATeamSection;
